import { Button } from 'components/common';
import useAnimationScreen from 'hooks/common/useAnimationScreen';
import useLottie from 'hooks/common/useLottie';
import { useEffect, useRef, useState } from 'react';

const FreeCoinReward = () => {
  const { animations, hide } = useAnimationScreen();
  const [phase, setPhase] = useState<0 | 1>(0);
  const [buttonShown, setButtonShown] = useState(false);

  const animation = animations.FreeCoinReward;
  const { amount } = animation.data;

  useEffect(() => {
    if (phase === 0) {
      setTimeout(() => {
        setButtonShown(true);
      }, 700);
    }
  }, [phase]);

  const onNext = () => {
    if (phase === 0) {
      setPhase(1);
    } else {
      hide(animation.id);
    }
  };

  return (
    <div className="relative h-full w-full">
      <div className="absolute bottom-0 z-10 flex w-full flex-col items-center justify-center">
        {phase === 0 ? <Phase0Content amount={amount} /> : null}
        {phase === 1 ? <Phase1Content /> : null}
        <div className="z-10 mb-8 mt-5 w-full px-4" style={{ opacity: buttonShown ? 1 : 0 }}>
          <Button onClick={onNext} style={{ text: brsc.confirm, color: 'btn-bg-primary', fontColor: 'btn-txt-primary', borderRadius: 'full' }} />
        </div>
      </div>
    </div>
  );
};

export default FreeCoinReward;

const Phase0Content = ({ amount }: { amount: number }) => {
  // phase 0
  const { element: popupElem, getStatus: getPopupStatus, play: playPopup } = useLottie({ path: '/imgweb/lottie/coin_pop.json', loop: false });
  const { currentProgress: currentPopupProgress } = getPopupStatus();

  const { element: pulseElem, play: playPulse } = useLottie({ path: '/imgweb/lottie/coin_pulse.json', useAutoplay: false, loop: true });
  const { element: heartElem, play: playHeart } = useLottie({ path: '/imgweb/lottie/heart_spread.json', useAutoplay: false, loop: false });

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (currentPopupProgress >= 0.99) {
      popupElem.current?.remove();
      playPulse();
    }
  }, [currentPopupProgress, popupElem, playPulse, playHeart]);

  useEffect(() => {
    setTimeout(() => {
      playHeart();
    }, 700);
  }, [playHeart]);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      if (currentPopupProgress < 0.7) {
        playPopup();
      }
    }, 3000);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="absolute inset-0" ref={heartElem} />
      <div className="h-[80dvw] w-[100dvw]">
        <div ref={popupElem} />
        <div ref={pulseElem} />
      </div>
      <div
        className="typography-title-lg flex w-full justify-center gap-1"
        style={{ opacity: currentPopupProgress >= 0.7 ? 1 : 0 }}
        dangerouslySetInnerHTML={{
          __html: brsc.swipe_promo_free_coin.replace('$param', amount).replace('<span>', '<span style="color: #FF4390;">'),
        }}
      />
    </>
  );
};

const Phase1Content = () => {
  return (
    <div className="flex flex-col">
      <div className="h-[80dvw] w-[90dvw]">
        <div className="relative flex h-full w-full flex-col items-center justify-center">
          <img className="absolute left-0 top-0 h-[90dvw] w-[90dvw]" src="/imgweb/promo/light.png" alt="" style={{ animation: 'spin 5s linear infinite' }} />
          <img className="absolute left-0 top-0 h-[90dvw] w-[90dvw]" src="/imgweb/promo/coin_effect.png" alt="" />
        </div>
        <div className="flex items-center justify-center">
          <DayLottie success={true} />
          <DayLottie success={false} />
          <DayLottie success={true} />
        </div>
      </div>
    </div>
  );
};

const DayLottie = ({ success }: { success: boolean }) => {
  const { element } = useLottie({ path: `/imgweb/lottie/reward_${success ? 'success' : 'fail'}.json`, loop: false, useAutoplay: true });

  return (
    <div className="relative h-14 w-14">
      <div className="absolute left-0 top-0 h-7 w-7 rounded-full" style={{ backgroundColor: 'var(--primitive-blue-gray-600)' }} />
      <div className="absolute left-0 top-0 h-full w-full" ref={element} />
    </div>
  );
};
